import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./index.module.css";
import { Link } from "react-router-dom";

const Career = () => {
    const { t } = useTranslation();

    return (
        <>
            <div className={styles.regContainer}>
                <div className={styles.regImgContainer}>
                    <div className={styles.regTitle}>
                        {t("Career.JobPosting")}
                    </div>
                    <div className={styles.regDesc}>
                        {t("Career.JobDescription")}
                    </div>
                </div>

                <div className={styles.careerContainer}>
                    <div className={styles.careerHeader}>
                        {t("Career.CRMManager")}
                    </div>
                    <div className={styles.careerSubHeader}>
                        {t("Career.JobDetails")}
                    </div>
                    <p>{t("Career.CRMJobDesc1")}</p>
                    <ul>
                        <li>{t("Career.CRMJobDesc2")}</li>
                        <li>{t("Career.CRMJobDesc3")}</li>
                        <li>{t("Career.CRMJobDesc4")}</li>
                    </ul>
                    <p>{t("Career.CRMJobResult")}</p>
                    <ul>
                        <li>{t("Career.CRMJobResult2")}</li>
                    </ul>
                    <p>{t("Career.CRMOtherTasks")}</p>

                    <div className={styles.careerSubHeader}>
                        {t("Career.Qualifications")}
                    </div>
                    <ul>
                        <li>{t("Career.RequiredExperience")}</li>
                        <li>{t("Career.RequiredSkills")}</li>
                        <li>{t("Career.RequiredTools")}</li>
                        <li>{t("Career.DecisionMakingSkills")}</li>
                        <li>{t("Career.CollaborationSkills")}</li>
                    </ul>
                </div>

                <div className={styles.careerContainer}>
                    <div className={styles.careerHeader}>
                        {t("Career.TAManager")}
                    </div>
                    <div className={styles.careerSubHeader}>
                        {t("Career.JobDetails")}
                    </div>
                    <ul>
                        <li>{t("Career.TAJobDesc1")}</li>
                        <li>{t("Career.TAJobDesc2")}</li>
                        <li>{t("Career.TAJobDesc3")}</li>
                    </ul>

                    <div className={styles.careerSubHeader}>
                        {t("Career.Qualifications2")}
                    </div>
                    <ul>
                        <li>{t("Career.TARequiredSkills")}</li>
                        <li>{t("Career.TARequiredExperience")}</li>
                    </ul>

                    <div className={styles.careerSubHeader}>
                        {t("Career.PreferredQualifications")}
                    </div>
                    <ul>
                        <li>{t("Career.TAPreferredExperience1")}</li>
                        <li>{t("Career.TAPreferredExperience2")}</li>
                    </ul>
                </div>

                <div className={styles.careerContainer}>
                    <div className={styles.careerHeader}>
                        {t("Career.TourGuide")}
                    </div>
                    <div className={styles.careerSubHeader}>
                        {t("Career.JobDetails")}
                    </div>
                    <ul>
                        <li>{t("Career.TourGuideDesc1")}</li>
                        <li>{t("Career.TourGuideDesc2")}</li>
                        <li>{t("Career.TourGuideDesc3")}</li>
                    </ul>

                    <div className={styles.careerSubHeader}>
                        {t("Career.Qualifications3")}
                    </div>
                    <ul>
                        <li>{t("Career.TourGuideRequiredSkills1")}</li>
                        <li>{t("Career.TourGuideRequiredSkills2")}</li>
                        <li>{t("Career.TourGuideRequiredSkills3")}</li>
                    </ul>

                    <div className={styles.careerSubHeader}>
                        {t("Career.PreferredQualifications2")}
                    </div>
                    <ul>
                        <li>{t("Career.TourGuidePreferredSkills1")}</li>
                        <li>{t("Career.TourGuidePreferredSkills2")}</li>
                        <li>{t("Career.TourGuidePreferredSkills3")}</li>
                        <li>{t("Career.TourGuidePreferredSkills4")}</li>
                    </ul>
                </div>

                <div style={{ margin: "0 0 20px 10px" }}>
                    <div className={styles.careerHeader}>
                        {t("Career.ApplicationInstructions")}
                    </div>
                    <div style={{ margin: "0 0 0 10px" }}>
                        <a href="mailto:info@lolotour.com">info@lolotour.com</a>
                        {t("Career.SendEmailInstructions")}
                        <Link className={styles.link} to="/contact">
                            {t("Career.ClickHere")}
                        </Link>
                        {t("Career.SendLinkedIn")}
                    </div>
                </div>
            </div>
        </>
    );
};

export default Career;
